module.exports = __webpack_public_path__ + "img/zf_tab_1-1.f9f2cae6.png";